import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router';
import qs from 'query-string';

function normalize(path) {
  return path.replace(/\/{2,}/g, '/');
}

export var makeRoute = function makeRoute(_ref) {
  var _ref$path = _ref.path,
      path = _ref$path === undefined ? null : _ref$path,
      _ref$component = _ref.component,
      component = _ref$component === undefined ? null : _ref$component,
      _ref$render = _ref.render,
      render = _ref$render === undefined ? null : _ref$render,
      _ref$exact = _ref.exact,
      exact = _ref$exact === undefined ? false : _ref$exact,
      _ref$conditionFn = _ref.conditionFn,
      conditionFn = _ref$conditionFn === undefined ? null : _ref$conditionFn;
  var parentPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var childRoutes = [];
  var fullPath = path ? normalize(parentPath + '/' + path) : parentPath;
  var obj = {
    path: path,
    parentPath: parentPath,
    fullPath: fullPath,
    component: component,
    render: render,
    exact: exact,
    childRoutes: childRoutes,
    then: function then(props) {
      var subRoute = makeRoute(props, fullPath);
      childRoutes.push(subRoute);
      return subRoute;
    },

    condition: function condition(_condition) {
      return makeRoute({ path: path, component: component, render: render, exact: exact, conditionFn: _condition }, parentPath);
    },

    // eslint-disable-next-line
    route: function route() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          renderFn = _ref2.render,
          overrideComponent = _ref2.component;

      var child = null;
      var useComponent = overrideComponent || component;

      if (renderFn || render) {
        child = React.createElement(Route, { key: fullPath, path: fullPath, render: renderFn || render, exact: exact });
      } else if (useComponent) {
        child = React.createElement(Route, { key: fullPath, path: fullPath, component: useComponent, exact: exact });
      } else {
        child = React.createElement(
          Route,
          { key: fullPath, path: fullPath, exact: exact },
          childRoutes.length ? React.createElement(
            Switch,
            null,
            childRoutes.map(function (childRoute) {
              return childRoute.route();
            })
          ) : null
        );
      }

      if (conditionFn) {
        return React.createElement(Route, {
          key: fullPath,
          path: fullPath,
          exact: exact,
          render: function render() {
            var result = conditionFn();
            return result || child;
          }
        });
      }

      return child;
    },

    url: function url() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var pathname = Object.keys(params).reduce(function (sum, key) {
        return sum.replace(':' + key, params[key]);
      }, fullPath);
      var searchStr = Object.keys(search).length > 0 ? '?' + qs.stringify(search) : '';
      return '' + pathname + searchStr;
    }
  };

  return obj;
};

export var routeShape = PropTypes.shape({
  url: PropTypes.func.isRequired,
  route: PropTypes.func.isRequired,
  condition: PropTypes.func
});